import { Injectable } from '@angular/core';
import { createRemoteJWKSet, jwtVerify } from 'jose'
import { domainApiUrl } from "../../../environments/environment";
import { JWTPayload } from "jose/dist/types/types";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TimsTokenService {
  private _jwtPayload: JWTPayload | undefined;

  constructor() {
  }

  private _isValid: boolean = false;

  public get isValid() {
    return this._isValid;
  }

  private _token: string | undefined;

  public get token() {
    return this._token;
  }

  public set token(token) {
    this._isValid = false;
    this._jwtPayload = undefined;
    this._token = token;
  }

  private _tokenValidated$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public get tokenValidated$() {
    return this._tokenValidated$;
  }

  public get collections() {
    return this._jwtPayload === undefined ? undefined : this._jwtPayload.collections as string[];
  }

  public get instanceId() {
    return this._jwtPayload === undefined ? undefined : this._jwtPayload.instanceId as string;
  }

  public isExpired() {
    return this._jwtPayload?.exp !== undefined && this._jwtPayload.exp <= Math.floor(Date.now() / 1000);
  }

  public hasCollection(collectionId: string) {
    return this.collections?.includes(collectionId) ?? false;
  }

  public async validate() {
    this._isValid = false;

    if (this._token) {
      try {
        const response = await this.verifySignature(this._token);
        this._jwtPayload = response.payload;
        this._isValid = true;
      } catch (err) {
        console.error(err);
      }
    }

    this._tokenValidated$.next(this._isValid);
    return this._isValid;
  }

  private async verifySignature(token: string) {
    const remoteJwkSet = createRemoteJWKSet(new URL(`${domainApiUrl}/.well-known/openid-configuration/jwks`));
    return await jwtVerify(token, remoteJwkSet, { issuer: domainApiUrl, algorithms: ['PS256'] });
  }
}